// config.js
const API_DOMAIN = 'https://logistica.lupnova.com:2087';
//const API_DOMAIN = 'https://192.9.200.125:9016';

export default API_DOMAIN;
